/**
 * 路径到图标的映射配置
 * 集中管理所有路由路径对应的 Element Plus 图标
 */

/**
 * 路径图标映射表
 * 使用 as const 确保类型安全和不可变性
 */
export const PATH_ICON_MAP = {
  // Dashboard
  '/dashboard': 'Monitor',

  // 用户模块
  userManage: 'User',
  '/member': 'UserFilled',
  '/memberBlacklist': 'Lock',
  '/memberSelfExclusion': 'WarningFilled'

  // 菜单管理
  // '/menuList': 'Menu',
  // '/menu': 'Menu',

  // 角色管理
  // '/roleList': 'Stamp',
  // '/role': 'Stamp',

  // 部门管理
  // '/deptList': 'OfficeBuilding',
  // '/dept': 'OfficeBuilding',
  // '/department': 'OfficeBuilding',

  // 系统管理
  // '/system': 'Setting',
  // '/setting': 'Setting',

  // 其他常用路径
  // '/home': 'HomeFilled',
  // '/profile': 'User',
  // '/settings': 'Setting',
  // '/about': 'InfoFilled',
  // '/help': 'QuestionFilled',
  // '/notification': 'Bell',
  // '/message': 'Message',
  // '/file': 'Document',
  // '/folder': 'Folder',
  // '/data': 'DataBoard',
  // '/chart': 'TrendCharts',
  // '/report': 'Document',
  // '/log': 'DocumentCopy',
  // '/order': 'List',
  // '/product': 'Grid',
  // '/goods': 'Shop',
  // '/customer': 'Avatar',
  // '/finance': 'CreditCard',
  // '/statistics': 'DataAnalysis'
} as const;

/**
 * 路径类型（从映射表中提取所有路径）
 */
export type IconPath = keyof typeof PATH_ICON_MAP;

/**
 * 图标名称类型（从映射表中提取所有图标）
 */
export type IconName = (typeof PATH_ICON_MAP)[IconPath];

/**
 * 默认图标名称
 */
export const DEFAULT_ICON = 'DocumentCopy' as const;

/**
 * 默认图标类型
 */
export type DefaultIcon = typeof DEFAULT_ICON;
